import { defineMessages } from 'react-intl-next';

const _default_1: {
	showFullListButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	showFullListButtonText: {
		id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
		defaultMessage: 'Show full list',
		description:
			'Initially we show the first few items on the list. Clicking this button will show the full list.',
	},
});
export default _default_1;
